import React from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '../../../../components';
import { setValues } from '../../../../store/slices/UI';

import classes from './TokenRequired.module.scss';

const TokenRequired = ({ hideModal }) => {
  // const { businessId } = useSelector(state => state.userData);
  const dispatch = useDispatch();

  const updateBelvo = () => {
    dispatch(setValues({ showBelvoWidget: true }));
  };

  return (
    <div className={classes.content}>
      <span className='bold-20'>Actualiza la sincronización de cuentas de cobro</span>
      <span className={`${classes.text} medium-16`}>
        Solo debes ingresar el último código que te envíamos al correo del representante legal de la empresa para actualizar esta
        sincronización.
      </span>
      <div className={classes.buttons}>
        <Button onClick={hideModal} custom='secondary'>
          Ahora no
        </Button>
        <Button onClick={updateBelvo}>Actualizar</Button>
      </div>
    </div>
  );
};

export default TokenRequired;
